import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { LinkedTableAddDialogComponent } from "./linked-table-add-dialog.component";

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,

    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule
  ],
  declarations: [
    LinkedTableAddDialogComponent
  ],
  exports: [
    LinkedTableAddDialogComponent
  ]
})
export class LinkedTableAddDialogModule {}
